import { Flex, Skeleton } from '@nilohealth/core-ui'
import { BignumberContainer, BignumberWrapper } from './bignumber.styles'

const BignumberSkeleton = () => {
  return (
    <BignumberWrapper>
      <BignumberContainer>
        <Flex direction="column" gap="quarck" css={{ mb: '$xxxsmall' }}>
          <Skeleton variant="text" css={{ height: '$micro', width: '100%' }} />
          <Skeleton variant="text" css={{ height: '$micro', width: '100%' }} />
          <Skeleton variant="text" css={{ height: '$micro', width: '$xxxlarge' }} />
        </Flex>
        <Flex direction="column" css={{ mb: '$xxxsmall' }}>
          <Skeleton variant="text" css={{ height: '$xxsmall', width: '$xxlarge' }} />
        </Flex>
        <Flex direction="column" gap="quarck">
          <Skeleton variant="text" css={{ height: '$micro', width: '$large' }} />
          <Skeleton variant="text" css={{ height: '$micro', width: '$xxxlarge' }} />
        </Flex>
      </BignumberContainer>
    </BignumberWrapper>
  )
}

export default BignumberSkeleton
